import { render, staticRenderFns } from "./MenuDivisiones.vue?vue&type=template&id=596a7fed&scoped=true&"
import script from "./MenuDivisiones.vue?vue&type=script&lang=js&"
export * from "./MenuDivisiones.vue?vue&type=script&lang=js&"
import style0 from "./MenuDivisiones.vue?vue&type=style&index=0&id=596a7fed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a7fed",
  null
  
)

export default component.exports